import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat } from '../utils/date-format';

@Pipe({
  name: 'localDate'
})
export class LocalDatePipe implements PipeTransform {
  constructor(private dateFormat: DateFormat) {}
  transform(value: any): any {
    if (!value || value === '') {
      return '';
    }
    try {
      return this.dateFormat.format(value, 'MM/dd/yyyy');
    } catch {
      return '';
    }
  }
}
